/* eslint-disable camelcase */
import { OptionType, SORT_ORDER, TableSortOption } from '@evinced-private/ui-common';

import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	ConditionInt,
	Mobile_Unique_IssuesSortFields,
	Mobile_Unique_IssuesSortOrder,
	Mobile_Unique_IssuesTextSearchFields
} from 'src/common/types/graphql.generated';

import { MobileDashboardUniqueIssuesQueryVariables } from '../MobileUniqueIssues.generated';

import { hasSelectedBusinessUnit } from './mobileFilterVariableBuilder';

const mobileUniqueIssuesSortFieldsMap: Record<string, Mobile_Unique_IssuesSortFields> = {
	issueType: Mobile_Unique_IssuesSortFields.IssueType,
	severity: Mobile_Unique_IssuesSortFields.Severity,
	appId: Mobile_Unique_IssuesSortFields.AppId,
	elementDescription: Mobile_Unique_IssuesSortFields.ElementDescription,
	firstSeen: Mobile_Unique_IssuesSortFields.FirstSeen,
	lastSeen: Mobile_Unique_IssuesSortFields.LastSeen,
	instanceCount: Mobile_Unique_IssuesSortFields.NumInstances
};

const mobileUniqueIssuesSortOrderMap: Record<SORT_ORDER, Mobile_Unique_IssuesSortOrder> = {
	[SORT_ORDER.ASC]: Mobile_Unique_IssuesSortOrder.Ascending,
	[SORT_ORDER.DESC]: Mobile_Unique_IssuesSortOrder.Descending
};

const buildDaysFilter = (dateRangeOptions?: OptionType[]): ConditionInt | undefined => {
	if (!dateRangeOptions?.length) {
		return { value: [30] };
	}

	const days = Number(dateRangeOptions[0].value);
	return Number.isNaN(days) ? { value: [30] } : { value: [days] };
};

export const buildMobileUniqueIssuesVariables = (
	filters: IFilterOptions,
	page: number,
	sizePerPage: number,
	sort?: TableSortOption
): MobileDashboardUniqueIssuesQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<MobileDashboardUniqueIssuesQueryVariables>({
		sortFieldsMap: mobileUniqueIssuesSortFieldsMap,
		sortOrderMap: mobileUniqueIssuesSortOrderMap
	});

	variablesBuilder.addPaginationParams(page, sizePerPage);

	const defaultSort: TableSortOption = {
		dataField: 'issueType',
		order: SORT_ORDER.DESC
	};
	variablesBuilder.addSortParam(sort || defaultSort);

	const daysFilter = buildDaysFilter(filters.dateRange);
	if (daysFilter) {
		variablesBuilder.addConditionParam('daysFilter', daysFilter.value);
	}

	variablesBuilder
		.addFilterParam('severityFilter', filters.severities)
		.addFilterParam('issueTypeFilter', filters.types);

	if (hasSelectedBusinessUnit(filters.unitId)) {
		variablesBuilder.addFilterParam('businessUnitFilter', filters.unitId);
	}

	const variables = variablesBuilder.getVariables();

	if (filters.searchValue) {
		const searchValue = filters.searchValue.toString().trim();
		if (searchValue) {
			variables.textSearch = {
				searchFields: [
					Mobile_Unique_IssuesTextSearchFields.IssueType,
					Mobile_Unique_IssuesTextSearchFields.AppId,
					Mobile_Unique_IssuesTextSearchFields.ElementDescription
				],
				searchValues: [searchValue],
				insensitive: true
			};
		}
	}

	return variables;
};
